module.exports = __webpack_public_path__ + "img/دایره.2d9aae0d.png";